import React, { Component, useRef } from "react";
import Delete from '../../../../assets/img/svg/delete.svg';
import del from "../../../../assets/img/svg/Del.svg"
import View from "../../../../assets/img/svg/view.svg"
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import $ from "jquery";
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import styles from "../../../../assets/jss/customStyle";
import { withStyles } from '@material-ui/core/styles';
import moment from "moment"
import axios from "axios";
import API from "../../../../_helpers/endpointService"
import { getSettingsFormat } from "../../../../actions/SettingsAction"
import EasyEdit from 'react-easy-edit';
import active from '../../../../assets/img/svg/active.svg';
import deactive from '../../../../assets/img/svg/deactive.svg';
import { Radio, RadioGroup, InputAdornment, IconButton, FormControlLabel, Checkbox, FormHelperText } from '@material-ui/core';
import upload from '../../../../assets/img/svg/upload.svg';
import { CssTextField } from "../../../custom/textField"

class ListViewTM extends Component {
    constructor(props) {
        super(props);
        this.inputFile = React.createRef();
        this.state = {
            ProjectId: 0,
            UserRole: "",
            isMobile: false,
            isView: false,
            DocsName: [],
            DocsListName: [],
            DocsListothersName: [],
            OthersDocs: [],
            TypeId: 0,
            OtherDeleteId: 0,
            status: "",
            updatedoc: [],
            tableData: {
                'ProjectId': 0,
                'Typeid': 0,
                'PageNumber': 1,
                'PageSize': 100,
            },
            documentlist: {
                'projectId': 0,
                'typeId': 0,
            },
            displaydoc: {
                'FileUrl': '',
                'ProjectDocumentId': 0,
                'DocumentDate': '',
                'DocumentName': '',
                'Comments': '',
                'ProjectDocumentTypeId': 0,
            },
            postdocs: {
                'ActionBy': '',
                'ActionDate': '',
                'ProjectDocumentId': 0,
                'ProjectId': 0,
                'Comments': '',
                'DocumentDate': '',
                'TypeId': 0,
                'ProjectDocumentTypeId': 0,
            },
            putcomments: {
                "Projectdocumentsid": 0,
                "Comments": "",
                "ActionBy": ""
            },
            putdate: {
                "Projectdocumentsid": 0,
                "ActionBy": "",
                "DocumentDate": ""
            },
            putstatus: {
                "Id": 0,
                "Status": "",
            },
            putmastercomments: {
                "Id": 0,
                "Comments": ""
            }
        }
    }

    componentDidMount() {
        this.getTypes("DocumentTypes")
        const { dispatch } = this.props;
        (localStorage.getItem("UserRoles") == "Admin" || localStorage.getItem("UserRoles") == "Supervisor") ? this.setState({ isView: true }) : this.setState({ isView: false })
        this.state.ProjectId = localStorage.getItem("DashId");
        this.state.postdocs.ProjectId = localStorage.getItem("DashId");
        this.state.documentlist.projectId = localStorage.getItem("DashId");
        this.state.tableData.ProjectId = localStorage.getItem("DashId");
        this.state.UserRole = localStorage.getItem("UserRoles");
        this.state.putcomments.ActionBy = localStorage.getItem("UserRoles");
        this.state.postdocs.ActionBy = localStorage.getItem("UserRoles");
        this.state.postdocs.ActionDate = moment(new Date()).format('YYYY-MM-DD');
        this.state.putdate.ActionBy = localStorage.getItem("UserRoles");
        this.setState({})
        this.props.dispatch(getSettingsFormat(this.state.ProjectId))
        this.interval = setInterval(() => {
            this.resize()
        }, 10);
    }

    getTypes = (data) => {
        let apiUrl = API.LOOKUP_DATA + '/type?type=' + data;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                // this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    if (response.data.length > 0) {
                        let type = response.data.filter((val) => val.Name == "TrainingModule")
                        this.state.tableData.Typeid = type[0].Id;
                        this.state.documentlist.typeId = type[0].Id;
                        this.state.postdocs.TypeId = type[0].Id;
                        this.state.TypeId = type[0].Id;
                        this.setState({})
                    }
                    this.documents(this.state.documentlist);
                    // this.dataTable(this.state.tableData);
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    documents = (data) => {
        let apiUrl = API.GET_DOCUMENTSLIST + '/List?projectId=' + data.projectId + '&typeId=' + data.typeId;
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    if (response?.data) {
                        if (response?.data.length == 1) {
                            this.state.displaydoc.FileUrl = response.data[0].Attachment.FileUrl;
                            this.state.displaydoc.ProjectDocumentId = response.data[0].ProjectDocumentId;
                            this.state.displaydoc.DocumentDate = response.data[0].DocumentDate;
                            // this.state.displaydoc.DocumentName = response.data[0].DocumentName;
                            // this.state.displaydoc.Comments = response.data[0].Comments;
                        }
                    }
                    this.setState({})
                    this.dataTable(this.state.tableData);
                } else {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    AttachFiles = (str, ind) => {
        this.inputFile.current.click();
    };

    dataTable = (data) => {
        let apiUrl = API.GET_DOCUMENTSNAME + '?ProjectId=' + data.ProjectId + '&Typeid=' + data.Typeid + '&PageNumber=' + data.PageNumber + '&PageSize=' + data.PageSize;
        // this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.state.updatedoc = [];
                    this.setState({})
                    this.setState({
                        DocsName: response.data,
                    })
                    if (response?.data.Data.length > 0) {
                        response?.data.Data.map((i) => (
                            i.Section == "DocumentName" ?
                                i.Items && i.Items.map((a) => (
                                    this.state.updatedoc.push(a)
                                ))
                                : ""
                        ))
                    }
                    this.setState({})
                    // this.state.displaydoc.FileUrl = this.state.updatedoc[0].Attachment.FileUrl;
                    this.state.displaydoc.ProjectDocumentTypeId = this.state.updatedoc[0].Id;
                    // this.state.displaydoc.DocumentDate = this.state.updatedoc[0].DocumentDate;
                    this.state.displaydoc.DocumentName = this.state.updatedoc[0].Name;
                    this.state.displaydoc.Comments = this.state.updatedoc[0].Comments;
                    this.state.render = true;
                    this.setState({})
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    componentWillUnmount() {
        clearInterval(this.interval);
        $("#TRAIN1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#TrainModule1 .MuiListItemText-primary").removeClass("fw-bolder");
        $("#TrainModule").addClass("d-none");
        $("#TrainModule").removeClass("d-block");
        $("#TML").removeClass("active-color");
        $("#TMT").removeClass("fw-bolder");
    }

    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }

        $("#TRAIN1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#TrainModule1 .MuiListItemText-primary").addClass("fw-bolder");
        $("#TrainModule").removeClass("d-none");
        $("#TrainModule").addClass("d-block");
        $("#TML").addClass("active-color");
        $("#TMT").addClass("fw-bolder");
    };
    sidebar = () => {
        this.props.navigate("/sidebar");
    }

    OpenPopup = () => {
        window.$("#deletepopup").modal("show")
    }

    DeleteItem = () => {
        window.$("#deletepopup").modal("hide")
        this.DeleteOthersApi(this.state.displaydoc.ProjectDocumentId, this.state.UserRole)
    }

    DeleteOthersApi = (data, role) => {
        let apiUrl = API.GET_DOCUMENTSLIST + '/projectDocumentIds?projectDocumentIds=' + data + '&actionby=' + role;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "DELETE",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.state.displaydoc = {
                        'FileUrl': '',
                        'ProjectDocumentId': 0,
                        'DocumentDate': '',
                        'DocumentName': '',
                        'Comments': '',
                        'ProjectDocumentTypeId': 0,
                    }
                    this.setState({})
                    this.documents(this.state.documentlist);
                    this.dataTable({
                        'ProjectId': localStorage.getItem("DashId"),
                        'Typeid': this.state.TypeId,
                        'PageNumber': 1,
                        'PageSize': 100,
                    })
                } else {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    UploadFile = (e) => {
        let formData = new FormData()
        Array.from(e.target.files).forEach(async (a) => {
            formData.append("formFiles", a)
        })
        this.Upload_File(this.state.postdocs, formData)
    }

    Upload_File = (data, formData) => {
        let apiUrl = API.GET_DOCUMENTSLIST + '/ProcessDocument?ActionBy=' + data.ActionBy + '&ActionDate=' + data.ActionDate + '&ProjectDocumentId=' + data.ProjectDocumentId + '&ProjectId=' + data.ProjectId + '&DocumentDate=' + data.DocumentDate + '&TypeId=' + data.TypeId + '&ProjectDocumentTypeId=' + data.ProjectDocumentTypeId;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "POST",
            url: apiUrl,
            data: formData,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.state.displaydoc = {
                        'FileUrl': '',
                        'ProjectDocumentId': 0,
                        'DocumentDate': '',
                        'DocumentName': '',
                        'Comments': '',
                        'ProjectDocumentTypeId': 0,
                    }
                    this.setState({})
                    this.documents(this.state.documentlist);
                    // this.dataTable({
                    //     'ProjectId': localStorage.getItem("DashId"),
                    //     'Typeid': this.state.TypeId,
                    //     'PageNumber': 1,
                    //     'PageSize': 100,
                    // })
                } else {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    updatecomments = (e, str) => {
        let data = {
            "Id": str.Id,
            "Name": str.Name,
            "Status": str.Status,
            "Comments": e.target.value.trim(),
            "Section": "DocumentName"
        }
        this.put_status(data)
    }

    put_comments = (data) => {
        let apiUrl = API.GET_DOCUMENTSLIST + '/UpdateDocumentField';
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "PUT",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.documents(this.state.documentlist);
                    this.dataTable(this.state.tableData);
                    this.props.navigate(`/trainingmodule`)
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                }
            });
    };

    handleInputChange = (e, str) => {
        this.state.DocsName.Data && this.state.DocsName.Data.map((i, ind) => (
            i.Items && i.Items.map((a, index) => (
                a.Id == str.Id ? str.Status = e.target.value : ""
            ))
        ))
        let data = {
            Comments: str.Comments,
            Id: str.Id,
            Name: str.Name,
            Section: "",
            Status: e.target.value,
        }
        this.put_status(data)
    }

    handleInputChange1 = (e, str) => {
        this.state.DocsName.Data && this.state.DocsName.Data.map((i, ind) => (
            i.Items && i.Items.map((a, index) => (
                a.Id == str.Id ? str.Comments = e.target.value : ""
            ))
        ))
        this.setState({})
        // let data = {
        //     Comments: str.Comments,
        //     Id: str.Id,
        //     Name: str.Name,
        //     Section: "",
        //     Status: e.target.value,
        // }
        // this.put_status(data)
    }

    handleInputChange2 = (e, str) => {
        this.state.displaydoc.Comments = e.target.value;
        this.setState({})
    }

    updatemastercomments = (e, str) => {
        let data = {
            "Id": str.Id,
            "Name": str.Name,
            "Status": str.Status,
            "Comments": e.target.value.trim(),
            "Section": ""
        }
        this.put_status(data)
    }

    updatemastercomments1 = (e, str) => {
        let data = {
            "Id": str.ProjectDocumentTypeId,
            "Name": str.DocumentName,
            "Status": null,
            "Comments": e.target.value.trim(),
            "Section": "DocumentName"
        }
        this.put_status(data)
    }

    put_status = (data) => {
        let apiUrl = API.LOOKUP_DATA + '/UpdateProjectLookupField';
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "PUT",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.documents(this.state.documentlist);
                    this.dataTable(this.state.tableData);
                    this.props.navigate(`/trainingmodule`)
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };


    handleInputChange3 = (e, str, val) => {
        this.state.displaydoc.Comments = e.target.value;
        this.setState({})
    }

    updatedoccomments = (e, str, val) => {
        this.setState({ FocusId: 0 })
        let data = {
            "Id": str.ProjectDocumentTypeId,
            "Name": str.DocumentName,
            "Status": null,
            "Comments": e.target.value.trim(),
            "Section": "DocumentName"
        }
        this.updatedoccommentsmodal(data)
        // if (val != "") {
        //     let data1 = {
        //         "Id": str.Id,
        //         "Name": str.Name,
        //         "Status": null,
        //         "Comments": e.target.value,
        //         "Section": val
        //     }
        //     this.updatedoccommentsmodal(data1)
        // }
    }

    updatedoccommentsmodal = (data) => {
        let apiUrl = API.LOOKUP_DATA + '/UpdateProjectLookupField';
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "PUT",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.documents(this.state.documentlist);
                    this.dataTable(this.state.tableData);
                    this.props.navigate(`/trainingmodule`)
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    render() {
        let { classes, menuToggle } = this.props;

        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row w-100 border-bottom mt-4">
                                <div className="col-6 mt-auto">
                                    <List className="pt-3 mt-4 pl-3" style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={this.sidebar} >
                                            <ListItemText id={"TRAIN" + "1"} className='  textNaviIcon' primary="Daily Tasks" />
                                            <NavigateNextIcon id="TRAIN" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='border-bottom' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-6 pt-2 mt-5 ">
                                    <h4>Training Module</h4>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }
                <div className="ml-auto scroll-hide" style={{ backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>
                    <div className="row" style={{ margin: this.state.isMobile ? "" : "5px" }}>
                        <div className="row px-3">
                            <div className="col-12 pt-2">
                                {this.state.isMobile ? <></> : <h6>Training Module</h6>}
                            </div>
                        </div>
                        <div className={this.state.isMobile ? "col-12 px-4 pt-2 mt-1" : "col-12 px-3 pt-2 mt-1"}>
                            <div className="table-responsive" style={{ width: "100%" }}>
                                <table id="Docstable" className="table table-borderless border-top border-bottom border-left border-right">
                                    <thead>
                                        <tr className="table-active">
                                            <th width="3%" className="border-right"><span className="spandoc-thead">S.No</span></th>
                                            <th className="border-right"><span className="spandoc-thead">Requirement List</span></th>
                                            <th className="border-right spannormalstatus-thead"><span className="spandoc-thead">Status</span></th>
                                            <th className="commentsrequire-td"><span className="spandoc-thead">Comments</span></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                            {this.state.DocsName.Data && this.state.DocsName.Data.map((i, ind) => (<>
                                                {i.Section == '' ? <>
                                                    {i.Items && i.Items.map((a, index) => (<>
                                                        {a.Name && a.Name != "" ?
                                                            <tr className="border-top" onMouseEnter={() => this.setState({ HoverId: a.Id })} onMouseLeave={() => this.setState({ HoverId: 0 })}>
                                                                <td className="border-right text-center align-middle"><span className="spandoc-td">{index + 1}</span></td>
                                                                <td className={`${window.innerWidth < 1080 ? "docwidthmobile-td" : "docwidth-td"} border-right align-middle`}>
                                                                    <span className="spandoc-td">{a.Name}</span>
                                                                </td>
                                                                <td className="spanstatusnormal-thead border-right align-middle">
                                                                    {/* {this.state.Error.InvestigationTypeError && this.state.Error.InvestigationTypeError ?
                                                    <>
                                                        <RadioGroup row aria-label="status" value={this.state.addData.Investigationtype} onChange={(e) => { this.handleInputChange(e, "Investigationtype") }} fullWidth className={classes.error}>
                                                            <FormControlLabel value="Verified" control={<Radio color="default" className={classes.error} />} label="Verified" size="small" />
                                                            <FormControlLabel value="In Progress" control={<Radio color="default" className={classes.error} />} label="In Progress" size="small" />
                                                        </RadioGroup>
                                                        <FormHelperText className={classes.error}>Required field must be filled in</FormHelperText></>
                                                    : */}
                                                                    {this.state.isView === false ?
                                                                        <span className="spandoc-tbody">{a.Status && a.Status}</span> :
                                                                        <RadioGroup row aria-label="status" value={a.Status} onChange={(e) => { this.handleInputChange(e, a) }} fullWidth>
                                                                            <FormControlLabel style={{ minWidth: '75px', maxWidth: '75px', color: "#000000" }} value="Verified" control={<Radio color="default" size="small" />} label="Verified" size="small" />
                                                                            <FormControlLabel style={{ minWidth: '99px', maxWidth: '99px', color: "#000000" }} value="In Progress" control={<Radio color="default" size="small" />} label="In Progress" size="small" />
                                                                        </RadioGroup>}
                                                                    {/* } */}
                                                                </td>
                                                                <td className="commentsrequire-td align-middle">
                                                                    <span className="spandoc-td">
                                                                        {this.state.isView === false ?
                                                                            <CssTextField
                                                                                multiline
                                                                                fullWidth
                                                                                disabled
                                                                                variant="outlined"
                                                                                type="text"
                                                                                value={a.Comments && a.Comments}
                                                                                InputProps={{
                                                                                    className: `border-radius padding-space ${classes.inputfieldAlign}`
                                                                                }}
                                                                            /> :
                                                                            <CssTextField
                                                                                multiline
                                                                                fullWidth
                                                                                variant="outlined"
                                                                                type="text"
                                                                                onChange={(e) => this.handleInputChange1(e, a)}
                                                                                onBlur={(e) => this.updatemastercomments(e, a)}
                                                                                value={a.Comments && a.Comments}
                                                                                InputProps={{
                                                                                    className: `border-radius padding-space ${classes.inputfieldAlign}`
                                                                                }}
                                                                            />
                                                                        }
                                                                    </span>
                                                                </td>
                                                            </tr> : <></>}
                                                    </>))}
                                                </> : ""}
                                            </>))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className={this.state.isMobile ? "col-12 px-4 pt-2 mt-3" : "col-12 px-3 pt-2 mt-3"}>
                            <div className="table-responsive" style={{ width: "100%" }}>
                                <table id="Docstable" className="table table-borderless border-top border-bottom border-left border-right">
                                    <thead>
                                        <tr className="table-active">
                                            <th width="3%" className="border-right"><span className="spandoc-thead">S.No</span></th>
                                            <th className="border-right"><span className="spandoc-thead">Document</span></th>
                                            <th className="border-right spandate-thead"><span className="spandoc-thead">Created On</span></th>
                                            <th className="comments-td"><span className="spandoc-thead">Comments</span></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                            <tr className="border-top">
                                                <td width="3%" className="border-right text-center align-middle"><span className="spandoc-td">1</span></td>
                                                <td className={`${window.innerWidth < 1080 ? "docwidthmobile-td" : "docwidth-td"} border-right align-middle`}>
                                                    <div className="col-12 m-0 p-0 row">
                                                        <div className="col-6 col-lg-6 col-md-6 col-sm-6 col-xl-6 overflow pl-0">
                                                            <span className="spandoc-td">{this.state.displaydoc.DocumentName && this.state.displaydoc.DocumentName}</span>
                                                        </div>
                                                        <div className="col-6 col-lg-6 col-md-6 col-sm-6 col-xl-6 p-0 space-doc">
                                                            {this.state.displaydoc.FileUrl && this.state.displaydoc.FileUrl != "" ? <>
                                                                <button className="completed-button">COMPLETED</button>
                                                                <a href={this.state.displaydoc.FileUrl} target="_blank" className="link-colors pl-2">
                                                                    <img src={View} className="cursorPointer pl-1 viewdel-td" />
                                                                    <span className="pl-1 cursorPointer link-color">View</span></a>
                                                                {this.state.isView ? <>
                                                                    <img src={Delete} className={`${this.state.isView == false ? "img-disabled" : ""} pl-2 cursorPointer viewdel-td`} onClick={() => { this.OpenPopup(this.state.displaydoc.ProjectDocumentId) }} />
                                                                    <span className={`${this.state.isView == false ? "span-disabled" : ""} pl-1 cursorPointer`} onClick={() => { this.OpenPopup(this.state.displaydoc.ProjectDocumentId) }}>Delete</span> </> : <></>}</> : <>
                                                                {this.state.isView ? <>
                                                                    <button className="pending-button mr-1">PENDING</button>
                                                                    <img src={upload} className="cursorPointer ml-4 uploadicon-td" onChange={(e) => this.UploadFile(e)} onClick={() => this.AttachFiles()} />
                                                                    <span className="pl-1 mr-5 cursorPointer" onChange={(e) => this.UploadFile(e)} onClick={() => this.AttachFiles()}>Upload</span>
                                                                    <input
                                                                        type="file"
                                                                        hidden
                                                                        multiple
                                                                        onChange={(e) => this.UploadFile(e)}
                                                                        ref={this.inputFile}
                                                                    />
                                                                    </>
                                                                    :<>
                                                                        <button className="pending-button mr-4">PENDING</button>
                                                                        <span className="pl-1 mr-5"></span>
                                                                    </>}
                                                                </>}
                                                            </div>
                                                    </div>
                                                </td>
                                                <td className="spandate-thead border-right align-middle">
                                                    <span className="spandoc-td">{this.state.displaydoc.DocumentDate && moment(this.state.displaydoc.DocumentDate).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}</span>
                                                </td>
                                                <td className={`${window.innerWidth < 1080 ? "commentsmobile-td" : "comments-td"} align-middle`}>
                                                    {this.state.displaydoc.FileUrl && this.state.displaydoc.FileUrl != "" ?
                                                        this.state.isView == false ?
                                                            <CssTextField
                                                                multiline
                                                                fullWidth
                                                                disabled
                                                                variant="outlined"
                                                                type="text"
                                                                value={this.state.displaydoc.Comments && this.state.displaydoc.Comments}
                                                                InputProps={{
                                                                    className: `border-radius padding-space ${classes.inputfieldAlign}`
                                                                }}
                                                            /> :
                                                            <CssTextField
                                                                multiline
                                                                fullWidth
                                                                variant="outlined"
                                                                type="text"
                                                                onBlur={(e) => this.updatemastercomments1(e, this.state.displaydoc)}
                                                                value={this.state.displaydoc.Comments && this.state.displaydoc.Comments}
                                                                onChange={(e) => this.handleInputChange2(e, this.state.displaydoc)}
                                                                InputProps={{
                                                                    className: `border-radius padding-space ${classes.inputfieldAlign}`
                                                                }}
                                                            />
                                                        : ""}
                                                </td>
                                            </tr> 
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal fade p-5 mt-5" id="deletepopup" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                    <div class="modal-dialog" role="document">
                        <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>

                            <div class="modal-body pb-0">
                                <h1 className="text-center">
                                    <img src={del}></img>

                                </h1>
                                <div className="text-center">
                                    <h5 class="fw-bold">Are you sure you want to delete?</h5> </div>
                            </div>
                            <div class="modal-footer border-top-0 m-auto">
                                <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.DeleteItem}><span className="" >Delete</span></button>
                                <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#deletepopup").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        settings: state.commonReducer.settings || [],
    };
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ListViewTM))
);
